<template>
  <div>
    <h1>Tables</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>